/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown> }} Delete_Transcript_TextInputs */

const en_delete_transcript_text = /** @type {(inputs: Delete_Transcript_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the transcript file for ${i?.project}?`)
};

const fr_delete_transcript_text = /** @type {(inputs: Delete_Transcript_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous vraiment supprimer le fichier de transcription pour ${i?.project} ?`)
};

const de_delete_transcript_text = /** @type {(inputs: Delete_Transcript_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie die Protokolldatei für ${i?.project} wirklich löschen?`)
};

const it_delete_transcript_text = /** @type {(inputs: Delete_Transcript_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare il file di trascrizione per ${i?.project}?`)
};

const ru_delete_transcript_text = /** @type {(inputs: Delete_Transcript_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить файл с расшифровкой для ${i?.project}?`)
};

const es_delete_transcript_text = /** @type {(inputs: Delete_Transcript_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Está seguro de que desea eliminar el archivo de transcripción de ${i?.project}?`)
};

const zh_cn2_delete_transcript_text = /** @type {(inputs: Delete_Transcript_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除 ${i?.project} 的成绩单文件吗？`)
};

const ja_delete_transcript_text = /** @type {(inputs: Delete_Transcript_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} のトランスクリプトファイルを削除してもよろしいですか?`)
};

const hi_delete_transcript_text = /** @type {(inputs: Delete_Transcript_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई ${i?.project} के लिए ट्रांसक्रिप्ट फ़ाइल को हटाना चाहते हैं?`)
};

const pt_pt2_delete_transcript_text = /** @type {(inputs: Delete_Transcript_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir o arquivo de histórico escolar de ${i?.project}?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete the transcript file for {project}?" |
*
* @param {Delete_Transcript_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_transcript_text = /** @type {((inputs: Delete_Transcript_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Transcript_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_delete_transcript_text(inputs)
	if (locale === "de") return de_delete_transcript_text(inputs)
	if (locale === "it") return it_delete_transcript_text(inputs)
	if (locale === "ru") return ru_delete_transcript_text(inputs)
	if (locale === "es") return es_delete_transcript_text(inputs)
	if (locale === "zh-CN") return zh_cn2_delete_transcript_text(inputs)
	if (locale === "ja") return ja_delete_transcript_text(inputs)
	if (locale === "hi") return hi_delete_transcript_text(inputs)
	if (locale === "pt-PT") return pt_pt2_delete_transcript_text(inputs)
	return en_delete_transcript_text(inputs)
});